module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/diffuser_2d5919.png";